// extracted by mini-css-extract-plugin
export default {"settingtabs":"settings_settingtabs__swqwb","settabs":"settings_settabs__kY8IL","setBox":"settings_setBox__LZAOM","setDangerBox":"settings_setDangerBox__Hrp9a"};